import { getSafeWindow } from '@wix/gg-common-lib/utils';

export const useFeatureToggle = (toggleId: string) => {
  const window = getSafeWindow();
  const experiments = window?.__EXPERIMENTS__ ?? {};
  return Boolean(experiments[toggleId]);
};
